<template>
  <div>
    <div class="text-xs-right">
      <v-btn class="white--text" small round color="teal" :to="{name: 'njangi_groups.new_group'}">
        <v-icon left class="fas fa-plus"></v-icon>
        <span> Join New Group</span>
      </v-btn>
    </div>

    <div v-if="groups.length === 0">
      <h1>No {{$route.params.category}} njangi group exists</h1>
    </div>

    <v-layout row wrap class="">
      <!-- CARTE DE GROUPE ACTIF -->
      <v-flex xs12 sm6 v-if="group_category == 'Active'" v-for="item in groups" :key="item.id" class="pa-1">
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="[
              `elevation-${hover ? 12 : 2}`,
              { 'inactive-group': !item.is_active }
            ]"
            style="border-radius: 10px; position: relative;"
          >
            <!-- Badge chat -->
            <div v-if="item.has_chat" class="chat-badge-wrapper">
              <v-btn fab small color="primary" class="chat-button elevation-4" @click.stop="openGroupChat(item)">
                <v-icon color="white">chat</v-icon>
              </v-btn>
              <span v-if="item.unread_messages > 0" class="custom-badge">
                {{ item.unread_messages }}
              </span>
            </div>

            <div
              @click="item.is_active && goToGroupDetail(item)"
              :style="item.is_active ? 'cursor: pointer;' : 'cursor: not-allowed;'"
            >
              <v-layout row wrap>
                <v-flex xs4 class="pa-1">
                  <v-img :src="item.get_image" height="120px"></v-img>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs8>
                  <v-card-text class="px-3 py-2" style="font-size: 12px;">
                    <h3 :class="titleColor">{{item.njangi_group_name}}</h3>

                    <v-chip
                      v-if="!item.is_active"
                      x-small
                      color="grey"
                      text-color="white"
                      class="ml-1 mb-1"
                    >
                      <i class="fa-solid fa-ban mr-1"></i> Inactive
                    </v-chip>

                    <span><b>Cycle:</b> {{item.collecting_cycle}}</span>
                    <v-spacer></v-spacer>
                    <span><b>Contribution:</b> {{ item.contribution_amount }} F CFA</span>
                    <v-spacer></v-spacer>
                    <span><b>Members:</b> {{ item.get_no_members }} </span>
                    <v-spacer></v-spacer>

                    <!-- ✅ Affichage du collecteur adapté à la période de grâce -->
                    <span v-if="isWeeklyGracePeriod(item) && previousCollectors[item.id]">
                      <b>Collector:</b> {{ previousCollectors[item.id].name }}
                      <span class="caption grey--text"></span>
                    </span>
                    <span v-else>
                      <b>Collector:</b> {{ item.get_current_collector }}
                    </span>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-hover>
      </v-flex>

      <!-- Carte pour les groupes "Applied" (inchangée) -->
      <v-flex xs12 sm6 v-if="group_category == 'Applied'" v-for="item in groups" :key="item.id" class="pa-1">
        <v-hover>
          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" style="border-radius: 10px; cursor: pointer; ">
            <v-card-text class="pt-2" style="font-size: smaller">
              <v-layout row wrap>
                <v-flex xs6 text-xs-left>
                  <span class="dark--text font-weight-bold">Type:</span> <span> {{item.njangi_contrib_interval}}</span>
                </v-flex>
                <v-flex xs6 text-xs-right>
                  <span class="dark--text font-weight-bold ">Amount:</span> <span> {{item.prefered_contrib_amount}} F CFA</span>
                </v-flex>
                <v-flex xs4 text-xs-left v-if="item.status == 'Pending'">
                  <span class="dark--text font-weight-bold">Status:</span> <span class="primary--text"> {{item.status}}</span>
                </v-flex>
                <v-flex xs4 text-xs-left v-if="item.status == 'Validated'">
                  <span class="dark--text font-weight-bold">Status:</span><span class="teal--text"> {{item.status}}</span>
                </v-flex>
                <v-flex xs4 text-xs-left v-if="item.status == 'Cancelled'">
                  <span class="dark--text font-weight-bold">Status:</span><span class="red--text"> {{item.status}}</span>
                </v-flex>
                <v-flex xs8 text-xs-right>
                  <span class="dark--text font-weight-bold ">Date:</span><span> {{item.get_date_str}}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'

// ════════════════════════════════════════════
// 🧪 TEST MODE — changer 5→6 pour tester
//    la grace period le vendredi
// ════════════════════════════════════════════
const WINDOW_OPEN_DAY = 5

function getWindowOpenDays() {
  return [0, 1, 2, 3].map(i => (WINDOW_OPEN_DAY + i) % 7)
}

export default {
  data() {
    return {
      groups: [],
      group_category: '',
      titleColor: '',
      chatRefreshInterval: null,
      // Pour stocker les collecteurs précédents calculés par groupe
      previousCollectors: {},
    }
  },

  methods: {
    isWeeklyGracePeriod(group) {
      if (group.collecting_cycle !== 'Weekly') return false
      const day = new Date().getDay()
      return !getWindowOpenDays().includes(day)
    },

    async getPreviousCollector(group) {
      try {
        // Récupérer la liste des membres avec positions pour ce groupe
        const dateHistory = this.getLastWeekDateHistory()
        const res = await axios.get(`/api/v1/njangi/get/user/group/members/${group.njangi_group_id}/${dateHistory}/`)
        const members = res.data.group_members_contrib_info

        if (!members.length) return null

        // Position du collecteur actuel (backend) = position du cycle suivant
        const currentPos = group.current_collect_position
        // Position précédente dans la rotation
        const total = members.length
        const prevPos = currentPos - 1 <= 0 ? total : currentPos - 1

        const prevMember = members.find(m => m.position === prevPos)
        return prevMember ? { name: prevMember.member_name, position: prevPos } : null
      } catch (e) {
        console.error('Error fetching previous collector:', e)
        return null
      }
    },

    getLastWeekDateHistory() {
      const now = new Date()
      const lastWeek = new Date(now)
      lastWeek.setDate(now.getDate() - 7)
      const year = lastWeek.getFullYear()
      const week = this.getNjangiWeekNumber(lastWeek)
      return `${year}-W${week.toString().padStart(2, '0')}`
    },

    getNjangiWeekNumber(date) {
      const d = new Date(date)
      d.setHours(0, 0, 0, 0)
      if (d.getDay() === 1) d.setDate(d.getDate() - 1)
      d.setDate(d.getDate() + 4 - (d.getDay() || 7))
      const yearStart = new Date(d.getFullYear(), 0, 1)
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
    },

    async getGroups() {
      this.$store.commit('setIsLoading', true)

      const group_category = this.$route.params.category
      try {
        const response = await axios.get('/api/v1/njangi/get/user/groups/' + group_category + '/')
        this.group_category = group_category
        this.groups = response.data

        // En période de grâce Weekly, récupérer le collecteur précédent pour chaque groupe
        const promises = this.groups.map(async (g) => {
          if (this.isWeeklyGracePeriod(g)) {
            const prev = await this.getPreviousCollector(g)
            if (prev) {
              this.$set(this.previousCollectors, g.id, prev)
            }
          }
        })
        await Promise.all(promises)

        if (group_category === 'All') this.titleColor = 'grey--text'
        else if (group_category === 'Active') this.titleColor = 'primary--text'
        else if (group_category === 'Applied') this.titleColor = 'red--text'
      } catch (error) {
        if (error.response) {
          this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
        } else {
          this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },

    openGroupChat(group) {
      this.$router.push({ name: 'njangi_group_chat', params: { group_id: group.njangi_group_id } })
    },

    goToGroupDetail(group) {
      this.$router.push('/njangi/groups/detail/' + group.njangi_group_id)
    },

    async refreshChatCounts() {
      try {
        const response = await axios.get('/api/v1/njangi/get/user/groups/Active/')
        response.data.forEach(newGroup => {
          const existingGroup = this.groups.find(g => g.njangi_group_id === newGroup.njangi_group_id)
          if (existingGroup) {
            existingGroup.unread_messages = newGroup.unread_messages
            existingGroup.has_chat = newGroup.has_chat
          }
        })
      } catch (error) {
        console.error('Error refreshing chat counts:', error)
      }
    }
  },

  watch: {
    '$route': function(to, from) {
      this.getGroups()
    }
  },

  mounted() {
    this.getGroups()
    const group_category = this.$route.params.category
    document.title = "PettyCash | " + group_category + " user's groups"

    if (group_category === 'Active') {
      this.chatRefreshInterval = setInterval(() => { this.refreshChatCounts() }, 30000)
    }
  },

  beforeDestroy() {
    if (this.chatRefreshInterval) clearInterval(this.chatRefreshInterval)
  }
}
</script>

<style scoped>
/* Styles inchangés */
.chat-badge-wrapper { position: absolute; top: 8px; right: 8px; z-index: 10; }
.custom-badge { position: absolute; top: -5px; right: -5px; background: #f44336; color: white; border-radius: 50%; width: 22px; height: 22px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: bold; z-index: 1; box-shadow: 0 2px 8px rgba(244, 67, 54, 0.4); animation: pulse-badge 2s infinite; }
@keyframes pulse-badge { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
.chat-button { transition: all 0.3s ease; }
.chat-button:hover { transform: scale(1.1); box-shadow: 0 4px 8px rgba(0,0,0,0.3) !important; }
.inactive-group { opacity: 0.65; filter: grayscale(40%); pointer-events: none; }
.inactive-group .chat-badge-wrapper { pointer-events: auto; }

/* ✅ WRAPPER POUR LE BOUTON ET LE BADGE */
.chat-badge-wrapper {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
}

.custom-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #f44336;
    color: white;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    z-index: 1;
    box-shadow: 0 2px 8px rgba(244, 67, 54, 0.4);
    animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
}

.chat-button {
    transition: all 0.3s ease;
}
.chat-button:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0,0,0,0.3) !important;
}

/* ✅ STYLE POUR LES GROUPES INACTIFS */
.inactive-group {
    opacity: 0.65;
    filter: grayscale(40%);
    pointer-events: none;  /* Bloque tous les clics sur la carte */
}

/* Le bouton de chat reste cliquable même dans une carte inactive ?
   On le réactive explicitement */
.inactive-group .chat-badge-wrapper {
    pointer-events: auto;
}
</style>